import { actions } from 'react/api/actions/wizard';
import { fromJS } from 'immutable';

const initialState = fromJS({});

export default (state = initialState, action) => {
  const { entity } = action.payload || {};

  switch (action.type) {
    case actions.goToNextSection: {
      const { page, sectionsLength } = action.payload;

      if (page === sectionsLength) {
        return state;
      }

      return state.mergeDeep({
        [entity]: {
          page: page + 1
        }
      });
    }

    case actions.goToPreviousSection: {
      const { page } = action.payload;

      if (page === 0) {
        return state;
      }

      return state.mergeDeep({
        [entity]: {
          page: page - 1
        }
      });
    }

    case actions.openCancelModal: {
      return state.mergeDeep({
        [entity]: {
          cancelModal: {
            modalIsOpen: true
          }
        }
      });
    }

    case actions.toggleCancelModal: {
      const cancelModalIsOpen = state.getIn([entity, 'cancelModal', 'modalIsOpen']);
      return state.mergeDeep({
        [entity]: {
          cancelModal: {
            modalIsOpen: !cancelModalIsOpen
          }
        }
      });
    }

    case actions.fetchInitialFormValues: {
      return state.mergeDeep({
        [entity]: {
          loadingInitialValues: true
        }
      });
    }

    case actions.fetchInitialFormValuesSuccess: {
      const { values } = action.payload;

      return state.mergeDeep({
        [entity]: {
          loadingInitialValues: false,
          initialValues: values
        }
      });
    }

    case actions.saveForm: {
      return state.mergeDeep({
        [entity]: {
          saving: true,
          saveError: false,
          errorMessage: ''
        }
      });
    }

    case actions.saveFormSuccess: {
      return state.mergeDeep({
        [entity]: {
          saving: false,
          saveSuccess: true
        }
      });
    }

    case actions.saveFormError: {
      const { error, customError } = action.payload;
      let errorMessage = '';
      if (error && error.errorMessages) {
        const { i18nMessage, key } = error.errorMessages[0].resource;
        errorMessage = i18nMessage || key;
      } else {
        errorMessage = customError || 'general.form.unknownError';
      }

      return state.mergeDeep({
        [entity]: {
          saving: false,
          saveError: !customError,
          errorMessage
        }
      });
    }

    case actions.clearFormError: {
      return state.mergeDeep({
        [entity]: {
          saving: false,
          saveError: false,
          errorMessage: null
        }
      });
    }

    case actions.clearFormState: {
      return state.set(entity, {});
    }

    default: {
      return state;
    }
  }
};
